import React, { useState, useEffect } from "react";
import "./doutor.css";
import AOS from "aos";
import 'aos/dist/aos.css';

function PageSobre() {
    const [listaSobre] = useState([
        { sobre: "Médico há 30 anos, formado em Medicina pela renomada Universidade de Brasília (UnB)." },
        { sobre: "Residência médica em Cirurgia Geral no Hospital Universitário de Brasília e em Cirurgia Plástica no Hospital Regional da Asa Norte (HRAN)." },
        { sobre: "Atua como cirurgião plástico no HRAN, referência em Brasília-DF." },
        { sobre: "Membro associado da Sociedade Brasileira de Cirurgia Plástica (SBCP)." },
        { sobre: "Membro ativo da Associação Brasileira de Cirurgia Plástica (BAPS)." },
        { sobre: "Afiliado à American Society of Plastic Surgeons (ASPS), destacando-se no cenário internacional." },
        { sobre: "Atualização constante através de cursos, palestras e congressos médicos, de forma presencial e on-line." },
        { sobre: "Reconhecido por sua dedicação à segurança, ética e resultados estéticos harmoniosos." },
    ]);

    const [listaDiferenciais] = useState([
        { sobre: "Localização privilegiada no Centro Médico Júlio Adnet, na Asa Sul de Brasília, com fácil acesso." },
        { sobre: "Atendimento humanizado e exclusivo, priorizando as necessidades e expectativas de cada paciente." },
        { sobre: "Estrutura moderna e equipada com tecnologia de ponta para maior conforto e segurança." },
        { sobre: "Utilização de programas de simulação de cirurgias em 3D (Crisalix), para planejamento visual e precisão nos resultados." },
        { sobre: "Uso de aparelho de ultrassonografia para um planejamento minucioso e individualizado de cada cirurgia, e seu acompanhamento no pós-operatório." },
        { sobre: "Uso de tecnologias modernas na realização das cirurgias como: Laser One S.T.E.P® ou SAFER® (VASER) nas lipoaspirações, fios farpados, funil de Keller nas cirurgias de mamoplastia." },
        { sobre: "Consultas personalizadas, com foco no entendimento detalhado de cada paciente, em um ambiente acolhedor e discreto, ideal para quem busca tranquilidade e privacidade." },
    ]);

    useEffect(() => {
        AOS.init({
            duration: 300,
            easing: "ease-out",
            once: true,
        });
    }, []);

    return (
        <main>
            {/* Conheça o Dr. Luciano Gazzoni */}
            <section id="sobre-dr">
                <header className="header-paginaSobre">
                    <div className="containerTop-lucianoGazzoni-paginaSobre">
                        <div className="row-lucianoGazzoni-paginaSobre" data-aos="fade-up">
                            <h2>Conheça o Dr. Luciano Gazzoni</h2>
                            <p>CRM 8493-DF | RQE 6960</p>
                            {listaSobre?.length > 0 && (
                                <div className="lista-sobre">
                                    <ul className="Ul-sobre-lucianoGazzoni-paginaSobre">
                                        {listaSobre.map((item, index) => (
                                            <li className="LI-sobre-lucianoGazzoni-paginaSobre" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                                <div className="lista">{item.sobre}</div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </header>
            </section>

            {/* Slogan */}
            <section id="slogan">
                <div className="container">
                    <div className="slogan">
                        <h4>Cuidando de você, com ética, respeito e resultados únicos.</h4>
                        <div className="assinatura-lg">
                            <h5>Confiança e acolhimento são os pilares do meu trabalho. Obrigado por me permitir fazer parte da sua jornada.</h5>
                            <div className="autograph-box" data-aos="fade-up" data-aos-delay="400">
                                <a href="#!">
                                    <img src="/images/sobre/assinatura.png" className="autograph" alt="Assinatura Luciano Gazzoni" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Lista Diferenciais */}
            <section id="lista-diferenciais">
                <div className="lista-diferenciais">
                    <h2 data-aos="fade-right">Diferenciais</h2>
                    <ul>
                        {listaDiferenciais.map((item, index) => (
                            <li key={index} data-aos="fade-right" data-aos-delay="500">
                                <div>{item.sobre}</div>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section id="instagram-dr">
                <div className="container">
                    <h3 className="titulo-acompanhe" data-aos="fade-up">Acompanhe o doutor nas redes sociais</h3>
                    <div className="buttons" data-aos="fade-up" data-aos-delay="500">
                        <a className="square-button" target="_blank" rel="noreferrer" href="https://www.instagram.com/drlucianogazzoni/"> <img className="icon-social-ig" src="/images/sobre/instagram.png" alt="Instagram"/></a>
                        <a className="square-button" target="_blank" rel="noreferrer" href="https://www.youtube.com/@LucianoGazzoni/shorts"><img className="icon-social-yt" src="/images/sobre/youtube.png" alt="YouTube"/></a>
                        <a className="square-button" target="_blank" rel="noreferrer" href="https://www.facebook.com/people/Dr-Luciano-Gazzoni-Cirurgi%C3%A3o-Pl%C3%A1stico/61552881904751/"><img className="icon-social-fb" src="/images/sobre/facebook.png" alt="Facebook" /></a>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default PageSobre;
